import styled from '../../custom/styled-components';

export default styled.h2`
  text-align: center;
`;
